<template>
  <!-- <el-row  class="row-header" type="flex" justify="center" >
    <el-col :xs="16" :sm="12" :md="12" :lg="14" :xl="12">
      <h2 class='header-h2'>{{ title_name }}</h2>
    </el-col>
  </el-row> -->
  <!-- <nav>
    <RouterLink to="/">Go to Home</RouterLink>
    <RouterLink to="/about">Go to About</RouterLink>
  </nav> -->
  <router-view/>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  data () {
    return {
        title_name: 'Haolin Lu \'s Homepage',
    };
  },
  methods: {
  },
}
</script>

<style>

@import "assets/font.css";

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}

html, body {
  margin: 0;
  padding: 0;
}

</style>